import { Button } from "@greeter/matter-v2";
import { PulsarTicket } from "../PulsarTicket/PulsarTicket";
import { IconSquaresSelected } from "@tabler/icons-react";

import css from "./NotFoundView.module.scss";

export type NotFoundViewProps = {
  onCreateNewEvent?: () => void;
  onChooseEvent?: () => void;
  empty?: boolean;
};

// TODO: Turn this into a composable element (for other pages)
export function NotFoundView(props: NotFoundViewProps) {
  return (
    <div className={css.NotFoundView}>
      <PulsarTicket />
      <div className={css.Description}>
        <h4>Ingen gæsteliste fundet</h4>
        <p>
          {props.empty
            ? "Der er ingen gæster på gæstelisten endnu."
            : "Vi fandt desværre ingen aktive events."}{" "}
        </p>
      </div>

      <div className={css.Buttons}>
        <Button
          variant="bright-green"
          className={css.Button}
          onClick={props.onChooseEvent}
        >
          <IconSquaresSelected />
          <span>Vælg et event</span>
        </Button>
      </div>
    </div>
  );
}
